import React from 'react';
import { Box, CircularProgress } from '@mui/material';

import useStyles from './styles';

function SplashScreen() {
  const classes = useStyles();

  return (
    <div className={classes.loadingPage}>
      <Box display="flex" justifyContent="center">
        <img className={classes.logo} src="/img/new_logo_cdtec_blue.png" alt="logo" />
      </Box>
      <CircularProgress style={{ color: 'var(--brand-blue)' }} />
    </div>
  );
}

export default SplashScreen;
